// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalUpdate_root__rZAlF","footer":"ModalUpdate_footer__3UAON"};